import { Dispatch, SetStateAction } from 'react';
import MagicUploadFilesTable from './MagicUploadFilesTable/MagicUploadFilesTable';
import MagicUploadCenter from './MagicUploadCenter/MagicUploadCenter';
import { MagicUploadFileData } from '../useFetchDataForMU';

type DrawerContentProps = {
    tabState: string;
    toggleDrawer: () => void;
    setFileData: Dispatch<SetStateAction<MagicUploadFileData[]>>;
    fileData: MagicUploadFileData[];
};

const DrawerContent = (props: DrawerContentProps) => {
    const { tabState, fileData, setFileData } = props;

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            {tabState === 'all' && (
                <div>
                    <MagicUploadCenter fileData={fileData} setFileData={setFileData} tabState={tabState} orientation={'vertical'} />
                </div>
            )}
            <MagicUploadFilesTable fileData={fileData} setFileData={setFileData} tabState={tabState} />
        </div>
    );
};

export default DrawerContent;
